export default __webpack_public_path__ + "static/linkedin-e5d02dee85aa7c39ceb7612376031afa.svg";